<template>
  <section>
    <div class="main update_trip_wrp">
      <div>
        <div>
          <div class="c-pointer">
            <a v-on:click.stop="updateTrip()">Update Transfer Point Trip</a>
          </div>
        </div>

        <div class="shedule_date_data_paddi">
          <div class="shedule_date_data">
            <div class="shedule_date_inner">
              <h5>Schedule Date and Time</h5>
              <p>
                {{
                  details.scheduleTime
                    ? details.scheduleTime
                    : "--"
                }}
              </p>
            </div>

            <div class="shedule_date_inner">
              <h5>Trip Start Date and Time</h5>
              <p>--</p>
            </div>

            <div class="shedule_date_inner">
              <h5>Trip End Date and Time</h5>
              <p>--</p>
            </div>

            <div class="shedule_date_inner">
              <h5>Trip Start Point</h5>
              <p>--</p>
            </div>

            <!-- next -->

            <div class="shedule_date_inner">
              <h5>Trip End Point</h5>
              <p>{{ details.endLoc ? details.endLoc.plantName : "--" }}</p>
            </div>
            <div class="shedule_date_inner">
              <h5>Driver</h5>
              <p>
                {{ details.driverId ? details.driverId.firstName + " " + details.driverId.lastName : "--" }}
              </p>
            </div>
            <div class="shedule_date_inner">
              <h5>Vehicle</h5>
              <p>{{ details.vehicleId ? details.vehicleId.vNumber : "--"}}</p>
            </div>
            <div class="shedule_date_inner">
              <h5>Total Waste (KG)</h5>
              <p>{{ details.totalWeight }}</p>
            </div>
            <!-- next -->
            <div class="shedule_date_inner">
              <h5>Status</h5>
              <p>{{ details.tripStatus }}</p>
            </div>
          </div>

          <div class="collection_division_details_ssec">
            <h3>Waste Transferred From</h3>
            <v-server-table class="surveyDetailsTable_paddi" ref="tripDetailsTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
              <template slot="beforeBody">
                <tr v-if="loading" class="VueTables__no-results">
                  <td class="text-center" colspan="9">
                    <pulse-loader></pulse-loader>
                  </td>
                </tr>
              </template>
            </v-server-table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { eventBus, secondaryTripService } from "../../../services";
import { USER_ROLES } from "../../../config";
import { ServerTable, Event } from "vue-tables-2";
import { mapState } from "vuex";

import store from "../../../store";
import swal from "sweetalert2";
import moment from "moment";
import dateFormatter from "../../utilities/dateFormate";

export default {
  name: "secondary",

  data() {
    return {
      loading: null,
      tripDetailsTable: null,
      wasteTransferFormTable: null,
      details: {},
      columns: ["vehicle", "driver", "helper", "area", "ward", "date", "totalWaste"],
      options: {
        highlightMatches: true,
        headings: {
          vehicle: "Primary Vehicle",
          driver: "Driver",
          helper: "Helper",
          area: "Area",
          ward: "Division/Ward",
          date: "Completion Date and Time",
          totalWaste: "Total Weight[KG]",
        },      
      perPage: 10,
      sortable: [],
      requestFunction: (request) => {
        return secondaryTripService.getWasteTransferredFromList(this.$route.params._id)
          .catch(error => {
            console.error('transferredFrom.requestFunction-error:', error);
            this.$snotify.error('Get wasteTransferredFrom', 'Error!');
          });
      },
      responseAdapter: (response) => {
        this.loading = false;
        let dataResp = [];
        response.data.forEach((element) => {
          let finalData = element;
          finalData["vehicle"] = element.vehicleId ? element.vehicleId.vNumber : "--";
          finalData["helper"] = element.helperId ? element.helperId.firstName + " " + element.helperId.lastName : "--";
          finalData["driver"] = element.driverId ? element.driverId.firstName + " " + element.driverId.lastName : "--";
          finalData["area"] = element.wasteCollectionArea ? element.wasteCollectionArea.areaName : "--";
          finalData["ward"] = element.divisionCount;
          finalData["date"] = element.completionDate ? element.completionDate : "--";
          finalData["totalWaste"] = element.wasteTransferred ? element.wasteTransferred : "--";
          dataResp.push(finalData);
        });
        return {
          data: dataResp,
          count: response.data.count || dataResp.length,
        };
      },
    },

    };
  },

  methods: {
    getTripInfo() {
      return secondaryTripService
        .getById(this.$route.params._id)
        .then((response) => {
          this.details = response.data;
          // const scheduledTime = moment(this.details.scheduleTime).format("DD-MM-YYYY , HH:MM A");
          let scheduledTime = this.details.scheduleTime ? dateFormatter(this.details.scheduleTime) : "--";
          this.details["scheduleTime"] = scheduledTime ;
          let tripStatuss = response.data.tripStatus;
          this.details["tripStatus"] =
            tripStatuss.charAt(0).toUpperCase() + tripStatuss.slice(1);
        });
    },
    onLoaded() {
      this.tripDetailsTable = this.$refs.tripDetailsTable;
    },
    updateTrip() {
      this.$router.push({
        name: "createSecondaryTrip",
        params: {
          _id: this.$route.params._id,
        },
      });
    },
  },

  created() {
    const promises = [];
    this.loading = true;
    if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
        promises.push(this.getTripInfo());
    }
    Promise.all(promises)
      .then(() => {
        this.loading = false;
        this.ready = true;
      })
      .catch(() => {
        this.loading = false;
      });
  },
};
</script>

<style>
.main {
  margin-left: 15px;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 90%;
  margin: 10px;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.Bold {
  font-weight: bold;
}
.max-widht-80 {
  max-width: 80px;
}
.update_trip_wrp .c-pointer {
  text-align: right;
  padding-right: 15px;
}
.update_trip_wrp .c-pointer a {
  color: #0f6940;
  font-weight: 700;
  font-size: 18px;
  padding-top: 10px;
  display: inline-block;
  text-decoration: underline;
}
.update_trip_wrp table {
  width: 99%;
  margin: 0;
  margin-top: 20px;
}
.update_trip_wrp .Bold {
  font-weight: bold;
  background: #0f6940;
  color: #fff;
}
.update_trip_wrp table th,
.update_trip_wrp table td {
  border: 1px solid #b3b0b0;
  padding: 10px;
}

.shedule_date_data {
  background: #0f6940;
  padding: 10px;
  display: flex;
  margin-top: 10px;
  color: #fff;
  flex-wrap: wrap;
}
.shedule_date_inner {
  flex: 0 0 25%;
  margin-bottom: 5px;
}
.shedule_date_data_paddi {
  padding-right: 15px;
}
.shedule_date_inner p {
  font-size: 15px;
  font-weight: 600;
}
.shedule_date_inner h5 {
  margin-bottom: 5px;
  font-size: 14px;
  color: #0ce595;
}
.collection_division_details_ssec h3 {
  font-size: 20px;
  font-weight: 700;
}
.update_trip_wrp {
  height: calc(100vh - 150px);
  overflow: auto;
  overflow-x: hidden;
}

.update_trip_wrp::-webkit-scrollbar {
  width: 5px;
}

.update_trip_wrp::-webkit-scrollbar-thumb {
  background: #888;
}

.surveyDetailsTable_paddi{
padding-right: 15px;
}
.surveyDetailsTable_paddi .VueTables__search{
padding-left: 15px;
}
.surveyDetailsTable_paddi .table-responsive {
  height: calc(100vh - 425px);
  overflow: auto;
  overflow-x: hidden;
}
.surveyDetailsTable_paddi .VuePagination {
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// secondary.vue?1dbec43c